import styled from '@emotion/styled'
import Switch from '@mui/material/Switch'
import theme from 'theme'

export const StyledSwitch = styled(Switch)`
  width: 38px;
  height: 20px;
  padding: 0;

  .MuiSwitch-switchBase {
    padding: 3px;

    &.Mui-checked {
      transform: translateX(18px);

      & + .MuiSwitch-track {
        background-color: ${theme.baseColors.surface[20]};
        border-color: ${theme.colors.borderMedium};
        opacity: 1;
      }

      .MuiSwitch-thumb {
        background-color: ${theme.baseColors.surface[20]};
        background-color: ${theme.colors.cta};
      }
    }
  }

  .MuiSwitch-thumb {
    width: 14px;
    height: 14px;
    background-color: ${theme.baseColors.greyscale[50]};
    box-shadow: none;
  }

  .MuiSwitch-track {
    border-radius: 35px;
    background-color: ${theme.baseColors.surface[20]};
    border: 2px solid ${theme.colors.borderMedium};
    opacity: 1;
  }

  html[data-theme='light'] & {
    .MuiSwitch-thumb {
      background-color: ${theme.colors.menuItemText};
    }

    .MuiSwitch-track {
      background-color: ${theme.colors.surfaceContainerBackground};
      border-color: ${theme.colors.strokePrimary};
    }

    .MuiSwitch-switchBase.Mui-checked {
      & + .MuiSwitch-track {
        background-color: ${theme.colors.surfaceContainerBackground};
        border-color: ${theme.colors.strokePrimary};
      }

      .MuiSwitch-thumb {
        background-color: ${theme.colors.cta};
      }
    }
  }
`
